import { FunctionalComponent, h } from 'preact';
import { useTranslation } from 'react-i18next';
import { CustomText } from 'components/CustomText';
import { Title, Button } from './RateSuccess.styled';

interface RateSuccessProps {
  onClose: () => void;
  customMessage?: string;
}

const RateSuccess: FunctionalComponent<RateSuccessProps> = ({
  onClose,
  customMessage,
}) => {
  const { t } = useTranslation();
  const message = customMessage || t('RATING_SUBMISSION_SUCCESS_MESSAGE');

  return (
    <div>
      <Title>
        <CustomText text={message} />
      </Title>
      <Button onClick={onClose}>{t('BUTTON_CLOSE')}</Button>
    </div>
  );
};

export default RateSuccess;
